import { LoginMethod } from '@linktivity/ars-neo';

export const DEFAULT_LOGIN_METHODS: LoginMethod[] = [
  LoginMethod.LoginMethodGoogle,
  LoginMethod.LoginMethodApple,
  LoginMethod.LoginMethodEmail
];
